import type { TableInputChoice } from "@tellescope/types-models";
import { DatePicker } from "@tellescope/ui";
import { Select, Input } from "@tellescope/design-system";
import { toDateStringAnswer, parseDateStringAnswer } from "../../utils";

export interface RelatedContactCustomFieldProps {
  choice: TableInputChoice;
  value: string;
  onChange: (newValue: string) => void;
  onBlur?: () => void;
}

export const RelatedContactCustomField = ({ choice, value, onChange, onBlur }: RelatedContactCustomFieldProps) => {
  if (choice.type === "Select") {
    return (
      <Select value={value} onValueChange={onChange}>
        <Select.Trigger onBlur={onBlur}>
          <Select.Value placeholder={choice.label}>{value}</Select.Value>
        </Select.Trigger>
        <Select.Content>
          {choice.info.choices.map((option) => (
            <Select.Item key={option} value={option}>
              {option}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
    );
  }

  if (choice.type === "Date") {
    const parsed = value ? parseDateStringAnswer(value) : null;
    return (
      <DatePicker
        value={parsed ? new Date(parsed.year, parsed.month - 1, parsed.day) : undefined}
        onChange={(date) => onChange(date ? toDateStringAnswer(date) : "")}
        onBlur={onBlur}
        placeholder={choice.label}
        label=""
      />
    );
  }

  return <Input value={value} onChange={(e) => onChange(e.target.value)} onBlur={onBlur} placeholder={choice.label} />;
};
